import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import { FeatureFlagKey, FeatureFlagsService } from '@brighthub/feature-flags';
import { map } from 'rxjs';
import { MyClientsLayoutComponent } from '../my-clients-layout/my-clients-layout.component';
import { FaAppLayoutComponent } from '../fa-app-layout/fa-app-layout.component';

function isFlagOn(value: unknown): boolean {
  return value !== false && value !== null && value !== undefined;
}

/**
 * Route-level wrapper for My Clients. Renders the panel layout when ENABLEFAAPP is on,
 * otherwise the legacy layout (client list behind flag + chat). Keeps the two flows
 * entirely separate for future changes.
 */
@Component({
  selector: 'bn-my-clients-route',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [MyClientsLayoutComponent, FaAppLayoutComponent],
  template: `
    @if (usePanelLayout()) {
      <bn-fa-app-layout />
    } @else {
      <bn-my-clients-layout />
    }
  `,
})
export class MyClientsRouteComponent {
  private readonly featureFlags = inject(FeatureFlagsService);

  /** True when ENABLEFAAPP is on: use panel layout (tabs + splitter). Reacts to flag changes. */
  readonly usePanelLayout = toSignal(
    this.featureFlags
      .getValueChanges$(FeatureFlagKey.ENABLEFAAPP, false)
      .pipe(map((v) => isFlagOn(v))),
    { initialValue: false }
  );
}
